import { Space, Typography, Tooltip, Collapse, Row, Col, InputNumber, Form, Select } from "antd";
import { InfoCircleOutlined } from '@ant-design/icons'
import React, { useEffect, useState, Fragment, useMemo } from "react";
import { StoreState } from "src/store/configureStore";
import { useSelector } from "react-redux";
import useTranslate from "src/utils/useTranslate";
import { useValue } from "src/utils/useValue";



const { Text } = Typography;

const columnStyle: React.CSSProperties = {
    padding: '8px 12px',
    display: 'flex',
    alignItems: 'center',
    borderRight: '1px solid #e8e8e8',
};
interface commonTableProps {
    headerRows: React.ReactNode
    data: { id: number }[]
    renderComponent: (row: any, index: number) => React.ReactNode
}

interface commonCollapseProps {
    labelValue: string;
    headerRows: React.ReactNode;
    tableData: (row: any, index: number) => React.ReactNode; // changed
    list: any[];
}

interface HeaderRowProps {
    headings: { span: number; label: string }[]
}

type DataTypeKey = 'ingredients' | 'processing' | 'properties' | 'formulations';
interface constraintProps {
    rows: {
        ingredients: any[];
        processing: any[];
        //characterization: any[];
    };
    setRows: React.Dispatch<React.SetStateAction<{
        ingredients: any[];
        processing: any[];
       // characterization: any[];
    }>>;
    initialConstraintsRef: React.RefObject<{ ingredients: any[], processing: any[], characterization: any[] }>
    setUnsavedChanges: React.Dispatch<React.SetStateAction<boolean>>;
    userIgnoredData: Record<DataTypeKey, string[]>;
    trialInputsData: Record<DataTypeKey, string[]>;
}


// const CharacterizationHeading = [
//     {
//         span: 8,
//         label: 'Characterization'
//     },
//     {
//         span: 6,
//         label: 'Base Input Range'
//     },
//     {
//         span: 5,
//         label: 'Minimum Value'
//     },
//     {
//         span: 5,
//         label: 'Maximum Value'
//     }
// ]

export const HeaderRow: React.FC<HeaderRowProps> = (props: HeaderRowProps) => {
    const { headings } = props;
    return (<Row style={{ borderBottom: '1px solid #e8e8e8', background: '#fafafa' }}>
        {headings?.map((item: any, idx) => (<Fragment key={`${item}-${idx}`}><Col span={item.span} style={columnStyle}><Text strong>{item.label}</Text></Col></Fragment>))}
    </Row>)
}

const IngredientsColumns = ({ data, onChange, onBlur }: { data: any; onChange: (vals: Partial<any>) => void, onBlur: (field: string, data: any) => void }) => {
    const [t] = useTranslate()
    const { convertValue, parser, formatter } = useValue();
    return (
      <Row
        gutter={16}
        align="middle"
        style={{ alignItems: "flex-start", marginBottom: 2 }}
      >
        <Col span={8} style={{ paddingLeft: 30 }}>
          {data?.name}
        </Col>
        <Col span={4} style={{ paddingLeft: 20 }}>
          {data?.categoricalDropdownOptions?.length > 0
            ? data?.categoricalDropdownOptions?.map(
                (item: any, idx: number) => (
                  <Fragment key={`${item}-${idx}`}>
                    <Text>
                      {item}
                      {idx === data?.categoricalDropdownOptions?.length - 1
                        ? ""
                        : ","}
                    </Text>
                  </Fragment>
                )
              )
            : `${convertValue(data?.startRange)} - ${convertValue(
                data?.endRange
              )}`}
        </Col>
        {data?.categoricalDropdownOptions?.length > 0 ? (
          <Col span={12}>
            <Form.Item
              validateStatus={
                data?.error && data?.errorType === "selectedOption"
                  ? "error"
                  : ""
              }
              help={
                data?.error && data?.errorType === "selectedOption" ? (
                  <div style={{ color: "red", fontSize: 10, marginTop: 4 }}>
                    {data?.errMsg}
                  </div>
                ) : data?.error && data?.errorType === "selectedOption" ? (
                  <div style={{ color: "red", fontSize: 10, marginTop: 4 }}>
                    {data?.errMsg}
                  </div>
                ) : (
                  ""
                )
              }
            >
              <Select
                allowClear
                showSearch
                mode="multiple"
                value={data?.selectedOption ?? []}
                onChange={(val) => onChange({ selectedOption: val })}
                options={
                  Array.isArray(data?.categoricalDropdownOptions)
                    ? data.categoricalDropdownOptions.map((opt: any) =>
                        typeof opt === "object"
                          ? opt
                          : { label: String(opt), value: String(opt) }
                      )
                    : []
                }
              />
            </Form.Item>
          </Col>
        ) : (
          <>
            <Col span={6}>
              <Form.Item
                validateStatus={
                  data?.error && data?.errorType === "minValue" ? "error" : ""
                }
                style={{ marginBottom: 0 }}
              >
                <InputNumber
                  formatter={formatter}
                  parser={parser}
                  value={data?.minValue}
                  style={{ width: "100%" }}
                  onChange={(val) => onChange({ minValue: val })}
                  onBlur={() => onBlur("minValue", data)}
                />
                <div
                  style={{
                    fontSize: 10,
                    marginTop: 2,
                    minHeight: 10, // fixed height for error/warning
                    color:
                      (data?.error && data?.errorType === "minValue") ||
                      (data?.startRange != null &&
                        !data?.error &&
                        data?.minValue <
                          convertValue(
                            tewntypercentPlusMinusRange?.(
                              data?.startRange,
                              data?.endRange
                            )?.min
                          ))
                        ? "red"
                        : "transparent",
                  }}
                >
                  {
                    data?.error && data?.errorType === "minValue"
                      ? data?.errMsg
                      : data?.startRange != null &&
                        !data?.error &&
                        data?.minValue <
                          convertValue(
                            tewntypercentPlusMinusRange?.(
                              data?.startRange,
                              data?.endRange
                            )?.min
                          )
                      ? `${t(
                          "extrapolation.constraints.warningMinRecommend"
                        )} ${convertValue(
                          tewntypercentPlusMinusRange?.(
                            data?.startRange,
                            data?.endRange
                          )?.min
                        )}`
                      : "\u00A0" /* non-breaking space */
                  }
                </div>
              </Form.Item>
            </Col>

            <Col span={6}>
              <Form.Item
                validateStatus={
                  data?.error && data?.errorType === "maxValue" ? "error" : ""
                }
                style={{ marginBottom: 0 }}
              >
                <InputNumber
                  formatter={formatter}
                  parser={parser}
                  value={data?.maxValue}
                  style={{ width: "100%" }}
                  onChange={(val) => onChange({ maxValue: val })}
                  onBlur={() => onBlur("maxValue", data)}
                />
                <div
                  style={{
                    fontSize: 10,
                    marginTop: 2,
                    minHeight: 10, // fixed height for error/warning
                    color:
                      (data?.error && data?.errorType === "maxValue") ||
                      (data?.endRange != null &&
                        !data?.error &&
                        data?.maxValue >
                          convertValue(
                            tewntypercentPlusMinusRange?.(
                              data?.startRange,
                              data?.endRange
                            )?.max
                          ))
                        ? "red"
                        : "transparent",
                  }}
                >
                  {data?.error && data?.errorType === "maxValue"
                    ? data?.errMsg
                    : data?.endRange != null &&
                      !data?.error &&
                      data?.maxValue >
                        convertValue(
                          tewntypercentPlusMinusRange?.(
                            data?.startRange,
                            data?.endRange
                          )?.max
                        )
                    ? `${t(
                        "extrapolation.constraints.warningMaxRecommend"
                      )} ${convertValue(
                        tewntypercentPlusMinusRange?.(
                          data?.startRange,
                          data?.endRange
                        )?.max
                      )}`
                    : "\u00A0"}
                </div>
              </Form.Item>
            </Col>
          </>
        )}
      </Row>
    );
};

// const CharacterizationColumns = ({ data, onChange, onBlur }: { data: any; onChange: (vals: Partial<any>) => void, onBlur: (field: string, data: any) => void }) => {
//     const [t] = useTranslate()
//     const { convertValue, parser, formatter } = useValue();
//     return (
//         <Row gutter={16} align="middle" style={{ alignItems: "flex-start", marginBottom: data?.maxValue > data?.endRange || data?.minValue < data?.startRange ? 36 : 12, }}>
//             <Col span={8} style={{ paddingLeft: 30 }}>
//                 {data?.name}
//             </Col>
//             <Col span={6} style={{ paddingLeft: 20 }}>
//                 {data?.categoricalDropdownOptions?.length > 0 ? data?.categoricalDropdownOptions?.map((item: any, idx: number) => (<Fragment key={`${item}-${idx}`}><Text>{item}{idx === data?.categoricalDropdownOptions?.length - 1 ? "" : ","}</Text></Fragment>)) : `${convertValue(data?.startRange)} - ${convertValue(data?.endRange)}`}
//             </Col>
//             {data?.categoricalDropdownOptions?.length > 0 ? (
//                 <Col span={10}>
//                     <Form.Item validateStatus={data?.error && data?.errorType === "selectedOption" ? "error" : ""} help={data?.error && data?.errorType === "selectedOption" ? <div style={{ color: 'red', fontSize: 10, marginTop: 4 }}>{data?.errMsg}</div> : (data?.error && data?.errorType === "selectedOption" ? <div style={{ color: 'red', fontSize: 10, marginTop: 4 }}>{data?.errMsg}</div> : "")}>
//                         <Select
//                             allowClear
//                             showSearch
//                             mode="multiple"
//                             value={data?.selectedOption ?? []}
//                             onChange={val => onChange({ selectedOption: val })}
//                             options={
//                                 Array.isArray(data?.categoricalDropdownOptions)
//                                     ? data.categoricalDropdownOptions.map((opt: any) =>
//                                         typeof opt === 'object'
//                                             ? opt
//                                             : { label: String(opt), value: String(opt) }
//                                     )
//                                     : []
//                             }
//                         />
//                     </Form.Item>
//                 </Col>
//             ) : <>
//                 <Col span={5}>
//                     <Form.Item
//                         validateStatus={data?.error && data?.errorType === "minValue" ? "error" : ""}
//                         help={data?.error && data?.errorType === "minValue" ? <div style={{ color: 'red', fontSize: 10, marginTop: 4 }}>{data?.errMsg}</div> : (data?.error && data?.errorType === "minValue" ? <div style={{ color: 'red', fontSize: 10, marginTop: 4 }}>{data?.errMsg}</div> : "")}
//                         style={{ marginBottom: 0 }}
//                     >
//                         <InputNumber
//                             formatter={formatter}
//                             parser={parser}
//                             value={data?.minValue}
//                             style={{ width: '100%' }}
//                             onChange={(val) => onChange({ minValue: val })}
//                             onBlur={() => onBlur("minValue", data)}
//                         />
//                         {!!data?.startRange && !data?.error && data?.minValue < convertValue(decreaseByTwentyPercent?.(data?.startRange)) && (
//                             <div style={{ color: 'red', fontSize: 12, marginTop: 10 }}>
//                                 {t("extrapolation.constraints.warningMinRecommend")} {convertValue(decreaseByTwentyPercent?.(data?.startRange))}
//                             </div>
//                         )}
//                     </Form.Item>
//                 </Col>
//                 <Col span={5}>
//                     <Form.Item
//                         validateStatus={data?.error && data?.errorType === "maxValue" ? "error" : ""}
//                         help={data?.error && data?.errorType === "maxValue" ? <div style={{ color: 'red', fontSize: 10, marginTop: 4 }}>{data?.errMsg}</div> : (data?.error && data?.errorType === "maxValue" ? <div style={{ color: 'red', fontSize: 10, marginTop: 4 }}>{data?.errMsg}</div> : "")}
//                         style={{ marginBottom: 0 }}
//                     >
//                         <InputNumber
//                             formatter={formatter}
//                             parser={parser}
//                             value={data?.maxValue}
//                             style={{ width: '100%' }}
//                             onChange={(val) => onChange({ maxValue: val })}
//                             onBlur={() => onBlur("maxValue", data)}
//                         />
//                         {!!data?.endRange && !data?.error && data?.maxValue > convertValue(increaseByTwentyPercent?.(data?.endRange)) && (
//                             <div style={{ color: 'red', fontSize: 12, marginTop: 10 }}>
//                                 {t("extrapolation.constraints.warningMaxRecommend")} {convertValue(increaseByTwentyPercent?.(data?.endRange))}
//                             </div>
//                         )}
//                     </Form.Item>
//                 </Col></>}
//         </Row>
//     );
// };

const ProcessingColumns = ({ data, onChange, onBlur }: { data: any; onChange: (vals: Partial<any>) => void, onBlur: (field: string, data: any) => void }) => {
    const [t] = useTranslate();
    const { convertValue, parser, formatter } = useValue();
    return (
        <Row gutter={16} align="middle" style={{ alignItems: "flex-start", marginBottom: 2 }}>
            <Col span={8} style={{ paddingLeft: 30 }}>
                {data?.name}
            </Col>
            <Col span={4} style={{ paddingLeft: 20 }}>
                {data?.categoricalDropdownOptions?.length > 0 ? data?.categoricalDropdownOptions?.map((item: any, idx: number) => (<Fragment key={`${item}-${idx}`}><Text>{item}{idx === data?.categoricalDropdownOptions?.length - 1 ? "" : ","}    </Text></Fragment>)) : `${convertValue(data?.startRange)} - ${convertValue(data?.endRange)}`}
            </Col>
            {data?.categoricalDropdownOptions?.length > 0 ? (
                <Col span={12}>
                    <Form.Item validateStatus={data?.error && data?.errorType === "selectedOption" ? "error" : ""} help={data?.error && data?.errorType === "selectedOption" ? <div style={{ color: 'red', fontSize: 10, marginTop: 4 }}>{data?.errMsg}</div> : (data?.error && data?.errorType === "selectedOption" ? <div style={{ color: 'red', fontSize: 10, marginTop: 4 }}>{data?.errMsg}</div> : "")}>
                        <Select
                            allowClear
                            showSearch
                            mode="multiple"
                            value={data?.selectedOption ?? []}
                            onChange={val => onChange({ selectedOption: val })}
                            options={
                                Array.isArray(data?.categoricalDropdownOptions)
                                    ? data.categoricalDropdownOptions.map((opt: any) =>
                                        typeof opt === 'object'
                                            ? opt
                                            : { label: String(opt), value: String(opt) }
                                    )
                                    : []
                            }
                        />
                    </Form.Item>
                </Col>
            ) : <>
            
            <Col span={6}>
                        <Form.Item
                            validateStatus={data?.error && data?.errorType === "minValue" ? "error" : ""}
                            style={{ marginBottom: 0 }}
                        >
                            <InputNumber
                                formatter={formatter}
                                parser={parser}
                                value={data?.minValue}
                                style={{ width: '100%' }}
                                onChange={(val) => onChange({ minValue: val })}
                                onBlur={() => onBlur("minValue", data)}
                            />
                            <div
                                style={{
                                    fontSize: 10,
                                    marginTop: 2,
                                    minHeight: 10,
                                    color:
                                        (data?.error && data?.errorType === "minValue") ||
                                        (data?.startRange != null &&
                                            !data?.error &&
                                            data?.minValue <
                                                convertValue(
                                                    tewntypercentPlusMinusRange?.(
                                                        data?.startRange,
                                                        data?.endRange
                                                    )?.min
                                                ))
                                            ? 'red'
                                            : 'transparent',
                                }}
                            >
                                {data?.error && data?.errorType === "minValue"
                                    ? data?.errMsg
                                    : data?.startRange != null &&
                                      !data?.error &&
                                      data?.minValue <
                                          convertValue(
                                              tewntypercentPlusMinusRange?.(
                                                  data?.startRange,
                                                  data?.endRange
                                              )?.min
                                          )
                                    ? `${t("extrapolation.constraints.warningMinRecommend")} ${convertValue(
                                          tewntypercentPlusMinusRange?.(data?.startRange, data?.endRange)?.min
                                      )}`
                                    : '\u00A0'}
                            </div>
                        </Form.Item>
                    </Col>

                    {/* Max Value */}
                    <Col span={6}>
                        <Form.Item
                            validateStatus={data?.error && data?.errorType === "maxValue" ? "error" : ""}
                            style={{ marginBottom: 0 }}
                        >
                            <InputNumber
                                formatter={formatter}
                                parser={parser}
                                value={data?.maxValue}
                                style={{ width: '100%' }}
                                onChange={(val) => onChange({ maxValue: val })}
                                onBlur={() => onBlur("maxValue", data)}
                            />
                            <div
                                style={{
                                    fontSize: 10,
                                    marginTop: 2,
                                    minHeight: 10,
                                    color:
                                        (data?.error && data?.errorType === "maxValue") ||
                                        (data?.endRange != null &&
                                            !data?.error &&
                                            data?.maxValue >
                                                convertValue(
                                                    tewntypercentPlusMinusRange?.(
                                                        data?.startRange,
                                                        data?.endRange
                                                    )?.max
                                                ))
                                            ? 'red'
                                            : 'transparent',
                                }}
                            >
                                {data?.error && data?.errorType === "maxValue"
                                    ? data?.errMsg
                                    : data?.endRange != null &&
                                      !data?.error &&
                                      data?.maxValue >
                                          convertValue(
                                              tewntypercentPlusMinusRange?.(
                                                  data?.startRange,
                                                  data?.endRange
                                              )?.max
                                          )
                                    ? `${t("extrapolation.constraints.warningMaxRecommend")} ${convertValue(
                                          tewntypercentPlusMinusRange?.(data?.startRange, data?.endRange)?.max
                                      )}`
                                    : '\u00A0'}
                            </div>
                        </Form.Item>
                    </Col>
                </>}
        </Row>
    );
};

// function increaseByTwentyPercent(value: number): number {
//     if (value === null || value === undefined) {
//         return 0
//     }
//     return value * 1.2;
// }
// function decreaseByTwentyPercent(value: number): number {
//     if (value === null || value === undefined) {
//         return 0
//     }
//     return value * 0.8;
// }

export function tewntypercentPlusMinusRange(start:number,end:number): { min: number, max: number } {
    if (start === null || start === undefined || end === null || end === undefined) {
        return { min: 0, max: 0 }
    }
    let difference = end - start;
    let tweentypercent = difference * 0.2;
    let min = start - tweentypercent;
    let max = end + tweentypercent;
    return {min, max};
}

const Constraints: React.FC<constraintProps> = (props: constraintProps) => {
    const [t] = useTranslate();
    const { rows, setRows, initialConstraintsRef, setUnsavedChanges, userIgnoredData, trialInputsData } = props;

    const { convertValue } = useValue();

    const { propertiesData } = useSelector((state: StoreState) => state.extrapolation)

    const { processing, characterizations, ingredients } = useSelector((state: StoreState) => state.displayNames?.data);

    useEffect(() => {
        // let characterizationArr: { name: string; startRange?: number; endRange?: number; id: number; key: any; identifier: string, minValue?: number, maxValue?: number, error: boolean, errorType: string, errMsg: string, categoricalDropdownOptions?: any, selectedOption?: any }[] = [];
        let ingredientArr: { name: string; startRange?: number; endRange?: number; id: number; key: any; identifier: string, minValue?: number, maxValue?: number, error: boolean, errorType: string, errMsg: string, categoricalDropdownOptions?: any, selectedOption?: any }[] = [];
        let processingArr: { name: string; startRange?: number; endRange?: number; id: number; key: any; identifier: string, minValue?: number, maxValue?: number, error: boolean, errorType: string, errMsg: string, categoricalDropdownOptions?: any, selectedOption?: any }[] = [];
        if (
            Object.keys(propertiesData || {}).length > 0
        ) {

            Object.entries(propertiesData?.Processings || {})?.forEach(([key, value]: any, index: number) => {
                const meta = processing?.[key];
                if (meta && trialInputsData?.processing?.includes(key) && !userIgnoredData?.processing?.includes(key)) {
                    if (Array.isArray(value)) {
                        if (value.length === 1 && value?.[0] === "") return;
                        processingArr?.push({
                            key,
                            name: meta?.name,
                            identifier: meta?.identifier,
                            categoricalDropdownOptions: value,
                            selectedOption: value,
                            id: index,
                            error: false,
                            errorType: "",
                            errMsg: ""
                        });
                    }
                    else {
                        processingArr?.push({
                            key,
                            name: meta?.name,
                            identifier: meta?.identifier,
                            startRange: convertValue(value?.min),
                            minValue: convertValue(value?.min),
                            maxValue: convertValue(value?.max),
                            endRange: convertValue(value?.max),
                            id: index,
                            error: false,
                            errorType: "",
                            errMsg: ""
                        });
                    }
                }
            });

            Object.entries(propertiesData?.Ingredients || {})?.forEach(([key, value]: any, index: number) => {
                const meta = ingredients?.[key];
                if (meta && trialInputsData?.ingredients?.includes(key) && !userIgnoredData?.ingredients?.includes(key)) {
                    if (Array.isArray(value)) {
                        if (value.length === 1 && value?.[0] === "") return;
                        ingredientArr?.push({
                            key,
                            name: meta?.name,
                            identifier: meta?.identifier,
                            categoricalDropdownOptions: value,
                            selectedOption: value,
                            id: index,
                            error: false,
                            errorType: "",
                            errMsg: ""
                        });
                    }
                    else {
                        ingredientArr?.push({
                            key,
                            name: meta?.name,
                            identifier: meta?.identifier,
                            startRange: convertValue(value?.min),
                            minValue: convertValue(value?.min),
                            maxValue: convertValue(value?.max),
                            endRange: convertValue(value?.max),
                            id: index,
                            error: false,
                            errorType: "",
                            errMsg: ""
                        });
                    }
                }
            });


            // Object.entries(propertiesData?.Characterizations || {})?.forEach(([key, value]: any, index: number) => {
            //     const meta = characterizations?.[key];
            //     if (meta) {
            //         if (Array.isArray(value)) {
            //             if (value.length === 1 && value?.[0] === "") return;
            //             characterizationArr?.push({
            //                 key,
            //                 name: meta?.name,
            //                 identifier: meta?.identifier,
            //                 categoricalDropdownOptions: value,
            //                 selectedOption: value,
            //                 id: index,
            //                 error: false,
            //                 errorType: "",
            //                 errMsg: ""
            //             });
            //         }
            //         else {
            //             characterizationArr?.push({
            //                 key,
            //                 name: meta?.name,
            //                 identifier: meta?.identifier,
            //                 startRange: convertValue(value?.min),
            //                 minValue: convertValue(value?.min),
            //                 maxValue: convertValue(value?.max),
            //                 endRange: convertValue(value?.max),
            //                 id: index,
            //                 error: false,
            //                 errorType: "",
            //                 errMsg: ""
            //             });
            //         }
            //     }
            // });

            const transformedData = {
                // characterization: characterizationArr,
                ingredients: ingredientArr,
                processing: processingArr
            }

            // ✅ Step 3: Set state ONCE
            setRows(transformedData);

            if (initialConstraintsRef.current == null && (initialConstraintsRef as React.MutableRefObject<any>).current !== undefined) {
                (initialConstraintsRef as React.MutableRefObject<any>).current = transformedData;
            }
        }
    }, [propertiesData, processing, characterizations, ingredients, setRows, initialConstraintsRef, userIgnoredData?.processing, userIgnoredData?.ingredients, convertValue, trialInputsData?.processing, trialInputsData?.ingredients]);

    const handleChange = (type: 'ingredients' | 'processing' , index: number, values: Partial<any>) => {
        setUnsavedChanges(true);
        if (values?.minValue) {
            values.minValue = convertValue(values?.minValue)
        }
        if (values?.maxValue) {
            values.maxValue = convertValue(values?.maxValue)
        }
        setRows(prev => ({ ...prev, [type]: prev[type]?.map((item, idx) => idx === index ? { ...item, ...values, error: false, errorType: "", errMsg: "" } : item) }));
    }

    const handleBlur = (section: string, index: number, field: string, row: any) => {
        if (section === 'ingredients') {
            if (field === 'minValue') {
                if (!row?.maxValue) {
                    return;
                }
                else if (row?.minValue > row?.maxValue) {
                    setRows(prev => ({ ...prev, ingredients: prev.ingredients?.map((item, idx) => idx === index ? { ...item, error: true, errorType: "minValue", errMsg: t("extrapolation.objective.minLessThanMax") } : item) }));
                }
            }
            else if (field === 'maxValue') {
                if (!row?.minValue) {
                    return;
                }
                else if (row?.minValue > row?.maxValue) {
                    setRows(prev => ({ ...prev, ingredients: prev.ingredients?.map((item, idx) => idx === index ? { ...item, error: true, errorType: "maxValue", errMsg: t("extrapolation.objective.maxLessThanMin") } : item) }));
                }
            }

        }
        else if (section === 'processing') {
            if (field === 'minValue') {
                if (!row?.maxValue) {
                    return;
                }
                else if (row?.minValue > row?.maxValue) {
                    setRows(prev => ({ ...prev, processing: prev.processing?.map((item, idx) => idx === index ? { ...item, error: true, errorType: "minValue", errMsg: t("extrapolation.objective.minLessThanMax") } : item) }));
                }
            }
            else if (field === 'maxValue') {
                if (!row?.minValue) {
                    return;
                }
                else if (row?.minValue > row?.maxValue) {
                    setRows(prev => ({ ...prev, processing: prev.processing?.map((item, idx) => idx === index ? { ...item, error: true, errorType: "maxValue", errMsg: t("extrapolation.objective.maxLessThanMin") } : item) }));
                }
            }
        }
        // else if (section === 'characterization') {
        //     if (field === 'minValue') {
        //         if (!row?.maxValue) {
        //             return;
        //         }
        //         else if (row?.minValue > row?.maxValue) {
        //             setRows(prev => ({ ...prev, characterization: prev.characterization?.map((item, idx) => idx === index ? { ...item, error: true, errorType: "minValue", errMsg: t("extrapolation.objective.minLessThanMax") } : item) }));
        //         }
        //     }
        //     else if (field === 'maxValue') {
        //         if (!row?.minValue) {
        //             return;
        //         }
        //     }
        // }
    }

    const IngredientsHeading =  useMemo(()=>{
        return [
            {
                span: 8,
                label: t("common.ingredients")
            },
            {
                span: 6,
                label: t("extrapolation.objective.baseInputRange")
            },
            {
                span: 5,
                label: t("extrapolation.objective.minValue")
            },
            {
                span: 5,
                label: t("extrapolation.objective.maxValue")
            }
        ]
    },[t])

    const ProcessingHeading = useMemo(()=>{
        return [
            {
                span: 8,
                label: t("common.processing")
            },
            {
                span: 6,
                label: t("extrapolation.objective.baseInputRange")
            },
            {
                span: 5,
                label: t("extrapolation.objective.minValue")
            },
            {
                span: 5,
                label: t("extrapolation.objective.maxValue")
            }
        ]
    },[t])






    return (<Space direction="vertical" style={{ width: "100%", marginTop: 42 }}>
        <Text strong>{t("extrapolation.constraints.inputConstraints")}</Text>
        <div
            style={{
                marginTop: 28,
                backgroundColor: '#e6f4ff',
                borderRadius: 6,
                padding: 12,
                display: 'flex',
                alignItems: 'center',
                marginBottom: 26
            }}
        >
            <Tooltip title={t("extrapolation.constraints.infoNote")}> <InfoCircleOutlined style={{ marginRight: 10 }} /></Tooltip>
            <Text strong style={{ whiteSpace: 'normal' }}>
                {t("extrapolation.constraints.infoNote")}
            </Text>
        </div>
        {rows.ingredients?.length > 0 && <CommonCollapse labelValue={t("common.ingredients")} headerRows={<HeaderRow headings={IngredientsHeading} />} tableData={(row, idx) => <IngredientsColumns data={row} onChange={(val) => handleChange('ingredients', idx, val)} onBlur={(field, val) => handleBlur('ingredients', idx, field, val)} />} list={rows.ingredients} />}
        {rows.processing?.length > 0 && <CommonCollapse labelValue={t("common.processing")} headerRows={<HeaderRow headings={ProcessingHeading} />} tableData={(row, idx) => <ProcessingColumns data={row} onChange={(val: Partial<any>) => handleChange('processing', idx, val)} onBlur={(field, val) => handleBlur('processing', idx, field, val)} />} list={rows.processing} />}
        {/* {rows.characterization?.length > 0 && <CommonCollapse labelValue="Characterization" headerRows={<HeaderRow headings={CharacterizationHeading} />} tableData={(row, idx) => <CharacterizationColumns data={row} onChange={(val: Partial<any>) => handleChange('characterization', idx, val)} onBlur={(field, val) => handleBlur('characterization', idx, field, val)} />} list={rows.characterization} />} */}

    </Space>)
}

export default Constraints;

export function CommonTableList(props: commonTableProps) {
    const { headerRows, data, renderComponent } = props;
    return (
        <Space direction="vertical" style={{ width: '100%' }}>
            {/* Header */}
            {headerRows}

            {/* Rows */}
            {data?.map((row, idx) => (
                <Fragment key={row.id}>
                    {renderComponent(row, idx)}
                </Fragment>
            ))}
        </Space>
    );


}

export function CommonCollapse(props: commonCollapseProps) {
    const { labelValue, headerRows, tableData, list } = props;
    const [rows, setRows] = useState<{ id: number }[]>([]);


    useEffect(() => {
        const res = list?.map((item, idx) => ({
            ...item,
            id: item.id ?? Date.now() + idx
        }));
        setRows(res);
    }, [list]);
    return (
        <Collapse
            defaultActiveKey={['1']}
            items={[{ key: '1', label: labelValue, children: <CommonTableList headerRows={headerRows} data={rows} renderComponent={tableData} /> }]}
        />
    )
}